<template>
  <div class="publish-task-product">
    <steps :active="0"></steps>
    <el-row  :gutter="30" class="main-wrapper">
      <el-col :xs="24" :sm="16" :md="16" :lg="16" :xl="16">
        <div class="box gray-box">
          <div class="box-header">
            <h3>购物车</h3>
          </div>
          <div class="add-product-container gray-txt" v-if="this.list">
            <add-products  class="add-product-container_add-button" v-on:success="getCartList" v-on:edit="editCallBack"><i class="el-icon-circle-plus-outline"></i> 添加商品</add-products>
             <div class="add-product-container_mini-tip">
              <svg
                t="1592188932771"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="2693"
                width="20"
                height="20"
              >
                <path
                  d="M402.2 734.6c-71.9 0-130.4-54.1-130.4-121 0-20.8 6-41.2 16.9-59.5 16.4-26.8 42.7-46.6 74.4-56 8.4-2.5 14.9-3.5 20.8-3.5 13.9 0 24.8 10.9 24.8 24.8s-10.9 24.8-24.8 24.8c-1 0-3 0-5.5 1-21.3 6-38.2 18.4-47.6 34.7-6.5 10.4-9.4 21.8-9.4 33.7 0 39.2 36.2 71.4 80.4 71.4 15.4 0 30.3-4 43.7-11.4 23.3-13.4 37.2-35.7 37.2-60V405.7c0-42.2 23.3-80.8 62-102.7 20.8-11.9 44.1-17.9 68-17.9 71.9 0 130.4 54.1 130.4 121 0 20.8-6 41.2-16.9 59.5-16.4 26.8-42.7 46.6-74.4 56-8.9 2.5-14.9 3.5-20.8 3.5-13.9 0-24.8-10.9-24.8-24.8s10.9-24.8 24.8-24.8c1 0 3 0 5.5-1 21.3-6.4 38.2-18.9 47.6-34.7 6.4-10.4 9.4-21.8 9.4-33.7 0-39.2-36.2-71.4-80.8-71.4-15.4 0-30.3 4-43.7 11.4-23.3 13.4-37.2 35.7-37.2 60v207.3c0 42.2-23.3 80.9-62 102.7-20.5 12.5-43.8 18.5-67.6 18.5z m504.4-223.2c0-219.2-177.6-396.8-396.8-396.8S113 292.1 113 511.4s177.6 396.8 396.8 396.8 396.8-177.6 396.8-396.8z m49.6 0c0 246.5-199.9 446.4-446.4 446.4-246.5 0-446.4-199.9-446.4-446.4C63.4 264.9 263.3 65 509.8 65c246.5 0 446.4 199.9 446.4 446.4z m0 0"
                  fill="#333333"
                  p-id="2694"
                />
              </svg>试试小程序
              <a>
                图文发布
                <div class="wx-qrcode">
                  <img src="../../../assets/images/homepage/weapp.jpg" height="84" width="84"/>
                </div>
              </a>？像发朋友圈一样简单！
            </div>
          </div>
          <div v-if="!this.list" class="text-center mt20">
            <Loading></Loading>
          </div>
          <div class="product-list box-body" v-if="!groupList[0] && this.list">
            <EmptyProduct v-on:success="getCartList" v-on:edit="editCallBack"></EmptyProduct>
          </div>
          <div class="product-list box-body" v-for="groupBusiness in groupList[0]">
            <product-list v-on:success="getCartList" v-on:edit="editCallBack" type="shoppingCart" :goods-list="groupBusiness"></product-list>
          </div>
        </div>
        <div class="box gray-box mt40" v-if="groupList[1]">
          <div class="box-header">
            <h3>稍后购买</h3>
          </div>
          <div class="product-list box-body" v-for="groupBusiness in groupList[1]">
            <product-list v-on:success="getCartList" v-on:edit="editCallBack" :goods-list="groupBusiness" type="buyLater"></product-list>
          </div>
        </div>
      </el-col>
      <el-col :xs="24" :sm="8" :md="8" :lg="8" :xl="8" style="margin-top: 84px;" class="mobile-order">
        <order-total :goods-list="taskInfo.goods_list" :groupList="groupList[0]"></order-total>
        <use-coupon></use-coupon>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AddProducts from './AddProducts'
import EmptyProduct from './EmptyProduct'
import ProductList from './ProductList'
import OrderTotal from '../components/OrderTotal'
import UseCoupon from '../components/UseCoupon'
import Steps from '../components/Steps'
import api from '../../../services/api.js'
import Loading from '../../../components/Loading'
import {AIService_HOST} from '../../../services/constant.js'
let _ = require('lodash')

export default {
  name: 'SelectBuyer',
  components: {
    addProducts: AddProducts,
    productList: ProductList,
    orderTotal: OrderTotal,
    useCoupon: UseCoupon,
    steps: Steps,
    EmptyProduct: EmptyProduct,
    Loading: Loading
  },
  data () {
    return {
      groupList: [],
      empty: null,
      list: null
    }
  },
  computed: {
    taskInfo () {
      let taskInfo = this.$store.state.taskInfo
      taskInfo.later_goods_list = taskInfo.later_goods_list || []
      return taskInfo
    },
    merchantList () {
      if (!this.list) return []

      console.log('list', this.list)
    }
  },
  created () {
    if(this.$route.query.isAIRetreave==1)
      this.getAIList()
    else
      this.getCartList()
  },
  methods: {
    editCallBack (goods) {
      _.each(this.list, item => {
        if (item.id == goods.id) {
          Object.assign(item, goods)
        }
      })
      this.extractMerchantList(this.list)
      this.$forceUpdate()
    },
    getAIList () {
      if (!localStorage.getItem('token')) return
      let url=AIService_HOST+"/crawlCart/getCartInfo"
      this.$http.get(url).then(data =>{
        this.list = data.body.data
        this.list.forEach((l)=>{
          l.business_name=l.merchant_name;
          l.business_id=l.merchant_id;
          l.business_website=l.merchant_website;
          l.spec=JSON.stringify(l.spec)
        })
        this.extractMerchantList(this.list)     
      })
    },
    async getCartList () {
      if (!localStorage.getItem('token')) return
      let res = await api.getCartList(this)
      let list = res.body.result || []
      this.list = list
      this.extractMerchantList(list)
    },
    extractMerchantList (list) {
      if (list.length == 0) {
        this.empty = true
        this.groupList[1] = null
        this.groupList[0] = null
        return
      } else {
        this.groupList[1] = []
        this.groupList[0] = []
      }

      list = _.orderBy(list, ['create_time'], ['desc'])
      _.each(list, item => {
        item.deleted = item.deleted || false
        if (item.status == 1 && !item.deleted) {
          this.groupList[1].push(item)
        } else if (item.status == 0) {
          this.groupList[0].push(item)
        }
      })
      if (this.groupList[1] && this.groupList[1].length) {
        this.groupList[1] = _.groupBy(this.groupList[1], 'business_name')
      } else {
        this.groupList[1] = null
      }
      if (this.groupList[0] && this.groupList[0].length) {
        this.groupList[0] = _.groupBy(this.groupList[0], 'business_name')
      } else {
        this.groupList[0] = null
      }
      this.$forceUpdate()
    },
    addProductSuccess () {
      this.getCartList()
    }
  },
  /*beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getCartList()
    })
  }*/
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.main-wrapper{
  margin-top: 30px;
  margin-bottom: 40px;
}

.product-list {
  margin-top: 20px;
  padding: 15px 30px 10px !important;

}
.add-product-container {
  display: flex;
  line-height: 28px;
  .icon {
    transform: translate(-10%, 20%);
  }
  &_add-button {
    width: 100px;
  }
  &_mini-tip {
    text-align: right;
    width: 100%;
    position: relative;
    a {
    cursor:pointer;
      position: relative;
      text-decoration: underline;
    }
    .wx-qrcode {
      display: none;
    }
    a:hover .wx-qrcode {
      display: block;
      position: absolute;
      left: -12px;

    }
  }
}
@media screen and (max-width:1024px){
  .main-wrapper{
    padding: 0 10px;
  }
  .product-list {
    padding: 15px 13px 0px !important;
    margin-top: 10px !important;

  }
  .style-revise {
    margin-top: 30px;
  }
  .mobile-order {
    margin-top: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/cart/Products.vue